"use client";

import Link from "next/link";
import { Share } from "lucide-react";

export const ShareButton = ({
  title,
  text,
  onShare,
}: {
  title: string;
  text: string;
  onShare?: () => void;
}) => {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: window.location.href,
        });

        if (onShare) onShare();
      } catch (error) {
        console.error("Erro ao compartilhar:", error);
      }
    } else {
      alert("O compartilhamento nativo não é suportado neste navegador.");
    }
  };

  return (
    <Link
      href="#"
      onClick={handleShare}
      aria-label={`Compartilhar ${title}`}
      className="cursor-pointer [transition:0.3s] m-0 p-0 border-[1px] border-[solid] outline-[none] text-[100%] rounded-[50%] w-[36px] h-[36px] leading-[32px] text-center [filter:drop-shadow(rgba(0,_0,_0,_0.05)_0px_10px_40px)] flex items-center justify-center"
    >
      <Share size={20} strokeWidth={1.5} />
    </Link>
  );
};
